
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.134 17.911a.71.71 0 00-1.004 0l-1.859 1.86a.709.709 0 101.004 1.003l1.86-1.86a.71.71 0 000-1.003zm-5.043-5.043a.709.709 0 00-1.004 0l-1.859 1.859a.71.71 0 001.003 1.004l1.86-1.86a.71.71 0 000-1.003zm3.362 1.68a.71.71 0 00-1.004 0l-4.712 4.713a.71.71 0 101.004 1.004l4.712-4.713a.71.71 0 000-1.003zM21.966.932l-6.725 20.58a.71.71 0 01-1.288.137L9.43 13.87a.71.71 0 01.044-.78l1.624-2.186-2.187 1.624a.71.71 0 01-.78.043L.355 8.05A.71.71 0 01.49 6.761L21.07.036a.71.71 0 01.896.895z","fill":"#000"}})])
          )
        }
      }
    